import { __rest } from "tslib";
import * as React from 'react';
import { DatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_CN';
import variables from '@web-common/styles/export.module.scss';
import classNames from 'classnames';
import './style.scss';
const { RangePicker } = DatePicker;
const IRangePicker = props => {
    const { className, width } = props, restProps = __rest(props, ["className", "width"]);
    const classes = React.useMemo(() => classNames(`${variables.classPrefix}-date-picker-range`, className), [className]);
    return React.createElement(RangePicker, Object.assign({ className: classes }, restProps, { style: Object.assign({}, (width ? { width: `${width}px` } : {})) }));
};
IRangePicker.defaultProps = {
    locale: locale,
    separator: React.createElement("span", { className: "separator" }),
    dropdownClassName: `${variables.classPrefix}-date-picker-dropdown`,
};
export default IRangePicker;
